import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'megapixels',
  standalone: true,
})
export class MegapixelsPipe implements PipeTransform {
  transform(value: number, rounded = false): number {
    if (rounded) return Math.round(value / 1000 / 10 / 100);
    return Math.round(value / 1000 / 10) / 100;
  }
}
